import PaymentSuccess from 'Components/Elements/PaymentSuccessElements/PaymentSuccess'

export default function PaymentSuccessPage() {
  return (
    <PaymentSuccess />
  )
}
